export default __webpack_public_path__ + "static/media/8.6f1d3efa.png";